var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 162.4986 106.1014",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 555.047,
    height: 194.299,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735",
    clipPath: "url(#clip-path)",
    transform: "matrix(1, 0, 0, 1, -196.271810658926, 0)",
    style: {
      transformOrigin: "196.272px 0px"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M317.531,49.263A53.057,53.057,0,0,0,239.287,6.43c-7.85,4.278-13.375,11.629-20.94,16.3-7.948,4.911-17.9,7.092-27.149,7.449a73.322,73.322,0,0,1-8.066.011c-5.858-.414-11.238-.24-16.422,2.8a23.566,23.566,0,0,0-9.545,10.645,22.81,22.81,0,0,0-1.867,6.988,23.2,23.2,0,0,0,20.748,25.519,53.6,53.6,0,0,0,10.005-.377,39.925,39.925,0,0,1,6.646.273,74.65,74.65,0,0,1,14.843,2.785,43.619,43.619,0,0,1,17.106,9.335c5.624,5.091,10.909,9.936,17.888,13.137a53.066,53.066,0,0,0,75-52.034M178.749,66.313A13.263,13.263,0,1,1,192.012,53.05a13.263,13.263,0,0,1-13.263,13.263m85.861,27.845A41.108,41.108,0,1,1,305.719,53.05a41.108,41.108,0,0,1-41.108,41.108",
    transform: "translate(41.102 0)",
    fill: "#8ed3fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmLogo);
export default __webpack_public_path__ + "static/media/dm_logo.649f2cd2396b8093333a246ae8e52763.svg";
export { ForwardRef as ReactComponent };